import { render, staticRenderFns } from "./platformList.vue?vue&type=template&id=59cfca8a&scoped=true&"
import script from "./platformList.vue?vue&type=script&lang=js&"
export * from "./platformList.vue?vue&type=script&lang=js&"
import style0 from "./platformList.vue?vue&type=style&index=0&id=59cfca8a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59cfca8a",
  null
  
)

export default component.exports